import * as ACT from './actions'
import { createReducer } from 'redux-create-reducer'

const initialState = {
  settings: null
}

const settingsReducer = createReducer(initialState, {
  [ACT.SETTINGS_FETCH_SUCCESS](state, action) {
    const { settings } = action.payload
    return {
      ...state,
      settings
    }
  }
})

export default settingsReducer
